var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('b-tabs',{attrs:{"card":""}},[_c('b-tab',{attrs:{"title":"Staff","active":""}},[_c('h3',[_vm._v("Staff")]),_c('staff-server-table',{attrs:{"show_columns":['last_name', 'email', 'work_groups.name']}})],1),_c('b-tab',{attrs:{"title":"Instruments"}},[_c('h3',[_vm._v("Instruments")]),_c('instrument-instance-server-table',{attrs:{"show_columns":['name', 'instrument.name', 'priority', 'description']}})],1),_c('b-tab',{attrs:{"title":"Test Packages"}},[_c('h3',[_vm._v("Test Packages")]),_c('test-package-server-table',{attrs:{"show_columns":[
          'name',
          'sample_type.name',
          'test_package_group.name',
          'description',
          'cost',
          'cost_add_on'
        ]}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }